import React from "react";
var __jsx = React.createElement;
import Markdown from "markdown-to-jsx";
import { useCheckoutOrder } from "@/common/Contexts/CheckoutOrderContext";
import { bnplItemToPurchaseMethod } from "./utils";
import BadgePill from "./BadgePill";
import BnplItemCard from "./BnplItemCard";
export default function BnplGroupCard(_ref) {
  var _section$items;
  var section = _ref.section,
    selectedSplitPaymentUrl = _ref.selectedSplitPaymentUrl,
    onSplitPaymentSelected = _ref.onSplitPaymentSelected,
    rejectionItems = _ref.rejectionItems,
    onInfoClick = _ref.onInfoClick;
  var action__setPurchaseMethod = useCheckoutOrder().actions.action__setPurchaseMethod;
  var items = (_section$items = section.items) !== null && _section$items !== void 0 ? _section$items : [];
  return /*#__PURE__*/React.createElement("div", {
    className: "overflow-hidden rounded-lg border border-solid border-[#e0e0e0]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-start gap-3 border-b border-solid border-[#e0e0e0] bg-white p-4 py-[19.5px]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex min-w-0 flex-1 flex-col gap-1 pl-8"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-start text-sm font-bold leading-5 [&_strong]:font-bold text-[#00143c]"
  }, /*#__PURE__*/React.createElement(Markdown, null, section.title)), section.sub_title && /*#__PURE__*/React.createElement("p", {
    className: "text-start text-xs leading-4 [&_strong]:font-bold text-[#6b7ea5]"
  }, /*#__PURE__*/React.createElement(Markdown, null, section.sub_title))), section.badge && /*#__PURE__*/React.createElement(BadgePill, {
    badge: section.badge
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col bg-white pb-2"
  }, items.map(function (item, idx) {
    var _rejectionItems$item$;
    var purchaseMethodValue = bnplItemToPurchaseMethod(item.method_type);
    var rejectionItem = (_rejectionItems$item$ = rejectionItems === null || rejectionItems === void 0 ? void 0 : rejectionItems[item.method_type]) !== null && _rejectionItems$item$ !== void 0 ? _rejectionItems$item$ : null;
    return /*#__PURE__*/React.createElement("div", {
      key: item.method_type
    }, idx > 0 && /*#__PURE__*/React.createElement("div", {
      className: "h-px w-full bg-[#e6e9ef]"
    }), /*#__PURE__*/React.createElement(BnplItemCard, {
      item: item,
      selectedSplitPaymentUrl: selectedSplitPaymentUrl,
      rejectionItem: rejectionItem,
      onSelect: function onSelect() {
        if (purchaseMethodValue) {
          action__setPurchaseMethod(purchaseMethodValue);
          onSplitPaymentSelected(null);
        }
      },
      onInfoClick: onInfoClick
    }));
  })));
}